import { observable, computed, action } from 'mobx';

class Rank {
	@observable type = 1;
   
	@action addPage = () => {
	  this.page ++;
	};
}

export default Rank